import customColorChooserView from './customColorChooserView.html';
import 'angular-bootstrap-colorpicker/css/colorpicker.css';
import './customColorChooser.css';

export default function customColorChooserComponent() {
	return {
		bindings: {
			hex: '=',
		},
		controllerAs: 'vm',
		template: customColorChooserView,
	};
}
